import { gql } from '@apollo/client';

export interface IReviewsCount {
  clubComments: {
    summary: {
      unread_total: number;
    };
  };
}
export const REVIEWS_COUNT = gql`
  query clubCommentsCount {
    clubComments {
      summary {
        unread_total
      }
    }
  }
`;
